// extracted by css-extract-rspack-plugin
export default {"TooltipContent":"aauPM","fadeIn":"BTGKx"};